export default __webpack_public_path__ + "static/media/Acusan-50-ban.c9df13a0.jpg";